module.exports = __webpack_public_path__ + "img/lv16.947881c9.png";